module.exports = require("./mas.js");